// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import vueCookie from 'vue-cookie'
import VueRouter from 'vue-router'

import App from './App'
import router from './router'
import Auth from './service/auth'
import Api from './api'

Vue.config.productionTip = false
Vue.use(Buefy)
Vue.use(vueCookie)
Vue.use(VueRouter)

Vue.prototype.$api = Api.api

init()

async function init() {
  await Auth.checkAndRedirect()

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    template: '<App/>',
    components: { App },
    router,
  })
}



// WEBPACK FOOTER //
// ./src/main.js